import * as React from 'react'

import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'

export interface ContextProps {
  closePortal: ClosePortalFn
}

export const PortalContext = React.createContext<ContextProps>({
  closePortal: () => {},
})

export const usePortal = () => React.useContext(PortalContext)
